import { useToasts } from "../../notify";

export function Toasts() {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  return (
    <div className="toasts">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast${t.info ? " info" : ""}`}
          role="status"
          onClick={() => {
            dismiss(t.id);
            t.onOpen?.();
          }}
        >
          <span className="ico">{t.info ? "✓" : "🔔"}</span>
          <span>
            <span className="tt">{t.title}</span>
            <span className="tx">{t.text}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
